import React, {Component} from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import {Observable} from "rxjs";
import {Place} from "app/model/place";
import {MapPosition} from 'app/model/mapPosition';
import {Translate} from "app/services/translate";
import {Button} from "../buttons/button";

export class Search extends Component {
    static get propTypes() {
        return {
            points: PropTypes.arrayOf(PropTypes.instanceOf(Place)).isRequired,
            handlePointSelect$: PropTypes.instanceOf(Observable).isRequired,
            handleGeolocationButtonClick$: PropTypes.instanceOf(Observable).isRequired,
            zoom: PropTypes.number.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {selectedPoint: null};
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.points = this.props.points.map((point) => ({
            value: new MapPosition(this.props.zoom, {lat: Number(point.lat), lng: Number(point.lng)}),
            label: String(point),
        }));
    }

    handleChange(option) {
        this.setState({selectedPoint: option});
        this.props.handlePointSelect$.next(option.value);
    }

    render() {
        return (
            <div className="search-container">
                <label htmlFor="search" className="search-label">{Translate('commons_agents_map_search_placeholder')}</label>
                <div className="search">
                    <span className="search-add-on"><i className="fas fa-search fa-lg" /></span>
                    <Select
                        value={this.state.selectedPoint}
                        className="search-input"
                        classNamePrefix="search-input"
                        placeholder={Translate('commons_agents_map_input_placeholder')}
                        noOptionsMessage={() => Translate('commons_agents_map_points_not_found')}
                        onChange={this.handleChange}
                        options={this.points} />
                    <Button
                        onClick$={this.props.handleGeolocationButtonClick$}
                        className="btn-location">
                        <i className="fas fa-crosshairs fa-lg"> </i>
                    </Button>
                </div>
            </div>
        );
    }
}
